import game from "./../../game";

//returns the pointer object
export function getPointer() {
  return [game.game.input.activePointer];
}
